export default theme => ({
  root: {
    padding: theme.spacing(10, 6),
  },
})
